import script from "./AIBudgetNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./AIBudgetNotice.vue?vue&type=script&setup=true&lang=js"

import "./AIBudgetNotice.vue?vue&type=style&index=0&id=58b4b309&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58b4b309"]])

export default __exports__